module.exports = __webpack_public_path__ + "media/images/404-dd24f1f1969d15ac02d49404c9048e6b.svg";